import React, { Component, PropTypes } from 'react';
import { Menu, Icon, Table, Button, Modal, Row, Col, Input, Form, Select, message, Spin } from 'antd';
import { browserHistory, Link } from 'react-router';
import _ from 'lodash';
import cn from 'classnames';
import { formItemLayout } from 'constants/layout';
import iconlist from 'constants/icon';

import { connect } from 'react-redux';
import { categorySwapIndex, subcategorySwapIndex } from 'redux/modules/category';
import { getCategories, upsertCategory, createNewSubCategory, updateSubCategory, deleteCategory, deleteSubcategory } from 'data/category';
import Utils from 'utils/utils';
import classes from './styles/Category.module.scss';

const Confirm = Modal.confirm;

// const SubMenu = Menu.SubMenu;
// const MenuItemGroup = Menu.ItemGroup;
const Option = Select.Option;
const FormItem = Form.Item;

class Category extends Component {
  constructor() {
    super();
    this.onClickRow = this.onClickRow.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.onMoveUp = this.onMoveUp.bind(this);
    this.onMoveDown = this.onMoveDown.bind(this);
    this.handleCancel = this.handleCancel.bind(this);

    this.onAddNewCategory = this.onAddNewCategory.bind(this);
    this.state = {
      collapseMobile: [],
      showModal: false,
      selectedPage: 'home',
    };
  }

  componentDidMount = async () => {
    const categories = await getCategories();
    this.setState({ categories });
  };

  componentWillMount() {
    this.setState({
      showModal: false,
    });
  }

  fetchCategories = async () => {
    const categories = await getCategories();
    this.setState({ categories });
  };

  onAddNewCategory() {
    this.setState({
      showModal: true,
      selectedRow: {
        subcategories: [],
      },
      isAddNew: true,
    });
  }

  onAddNewSubcategory(record) {
    this.setState({
      showModal: true,
      selectedRow: {
        parent: record._id,
      },
      isAddNew: true,
    });
  }

  onClickRow(record, index) {
    this.setState({
      showModal: true,
      selectedRow: record,
      isAddNew: false,
    });
  }

  swapSubcategory = (catId, id1, id2) => {
    const cat = _.find(this.state.categories, { _id: catId });

    const subcat1Index = _.find(cat.subcategories, { _id: id1 }).index;
    const subcat2Index = _.find(cat.subcategories, { _id: id2 }).index;
    cat.subcategories = cat.subcategories.map((subcat) => {
      if (subcat1Index === subcat.index) {
        subcat.index = subcat2Index;
      } else if (subcat2Index === subcat.index) {
        subcat.index = subcat1Index;
      }
      return subcat;
    });
    cat.subcategories = _.orderBy(cat.subcategories, 'index');
    const newCategories = this.state.categories.map((category) => {
      if (category._id === catId) {
        return cat;
      }
      return category;
    });
    return { ...this.state, categories: newCategories };
  };

  swapCategory = (id1, id2) => {
    const cat1Index = _.find(this.state.categories, { _id: id1 }).index;
    const cat2Index = _.find(this.state.categories, { _id: id2 }).index;
    const newCats = this.state.categories.map((cat) => {
      if (cat1Index === cat.index) {
        cat.index = cat2Index;
      } else if (cat2Index === cat.index) {
        cat.index = cat1Index;
      }
      return cat;
    });
    return { ...this.state, categories: newCats };
  };

  onDelete(record) {
    const type = record.subcategories ? 'category' : 'subcategory';
    if (type === 'category') {
      deleteCategory(record._id)
        .then(() => {
          this.fetchCategories();
        })
        .catch((err) => {
          message.error(err.message);
        });
    } else {
      deleteSubcategory(record._id)
        .then(() => {
          this.fetchCategories();
        })
        .catch((err) => {
          message.error(err.message);
        });
    }
  }

  onMoveUp(record) {
    const type = record.subcategories ? 'category' : 'subcategory';
    const { categories } = this.state;
    if (type === 'category') {
      const aboveRow = _.find(categories, { index: record.index - 1 });
      this.swapCategory(record._id, aboveRow._id);
      upsertCategory(record).then(() => {
        upsertCategory(aboveRow);
      });
      this.forceUpdate();
    } else {
      // console.log(record.rowIndex);
      const parentCat = _.find(categories, { _id: record.parent });
      const aboveRow = _.find(parentCat.subcategories, { rowIndex: record.rowIndex - 1 });
      this.swapSubcategory(parentCat._id, record._id, aboveRow._id);
      updateSubCategory(record).then(() => {
        updateSubCategory(aboveRow);
      });
      this.forceUpdate();
    }
  }

  onMoveDown(record) {
    const type = record.subcategories ? 'category' : 'subcategory';
    const { categories } = this.state;
    if (type === 'category') {
      const belowRow = _.find(categories, { index: record.index + 1 });
      this.swapCategory(record._id, belowRow._id);
      upsertCategory(record).then(() => {
        upsertCategory(belowRow);
      });

      this.forceUpdate();
    } else {
      const parentCat = _.find(categories, { _id: record.parent });
      const belowRow = _.find(parentCat.subcategories, { rowIndex: record.rowIndex + 1 });
      this.swapSubcategory(parentCat._id, record._id, belowRow._id);
      updateSubCategory(record).then(() => {
        updateSubCategory(belowRow);
      });
      this.forceUpdate();
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        if (values.type === 'Category') {
          try {
            await upsertCategory(values);
            await this.fetchCategories();
          } catch (error) {
            message.error(error.message);
            return;
          }
          this.setState({
            showModal: false,
            isAddNew: false,
          });
        } else {
          try {
            if (!values._id) {
              await createNewSubCategory(values);
            } else {
              await updateSubCategory(values);
            }
            await this.fetchCategories();
          } catch (error) {
            message.error(error.message);
            return;
          }
          this.setState({
            showModal: false,
            isAddNew: false,
          });
        }
      }
    });
  }

  handleCancel() {
    this.setState({
      showModal: false,
      selectedRow: null,
      isAddNew: false,
      confirmDirty: false,
      getFieldDecorator: false,
      showNewPageModal: false,
    });
  }

  showDeleteConfirm(record, msg, content) {
    Confirm({
      title: msg,
      content: content || '',
      onOk: () => this.onDelete(record),
      onCancel: this.onCancel,
    });
  }

  columns = [
    {
      title: 'Category name',
      dataIndex: 'name',
      render: (value, record) => (
        <span>
          {!record.subcategories && <Icon type="right" />}&nbsp;
          <a onClick={() => this.onClickRow(record)}>{value}</a>&nbsp; {record.subcategories && <span>({record.subcategories.length})</span>}
        </span>
      ),
    },
    {
      title: 'Class count',
      dataIndex: 'classCount',
    },
    {
      title: '',
      dataIndex: '_id',
      width: '150px',
      classname: 'text-right',
      render: (value, record, i) => {
        const type = record.subcategories ? 'category' : 'subcategory';
        const index = type === 'category' ? i + 1 : record.rowIndex + 1;
        console.log(record.name, record.rowIndex, record.index);
        return (
          <div>
            {index > 1 && (
              <Button className={'btn-icon'} type="success" onClick={() => this.onMoveUp(record)}>
                <Icon type="caret-up" className="icon-small" />
              </Button>
            )}
            &nbsp;
            {index < record.length && (
              <Button className={'btn-icon'} type="danger" onClick={() => this.onMoveDown(record)}>
                <Icon type="caret-down" className="icon-small" />
              </Button>
            )}
            &nbsp;
          </div>
        );
      },
    },
    {
      title: '',
      render: (value, record) => {
        return (
          <div>
            {record.subcategories && <Button onClick={(e) => this.onAddNewSubcategory(record)}>เพิ่มหมวดหมู่ย่อย</Button>}&nbsp;
            <Button type="danger" onClick={(e) => this.showDeleteConfirm(record, `ยืนยันการลบ ${record.name}`)}>
              <Icon type="delete" />
            </Button>
          </div>
        );
      },
    },
  ];

  renderModal() {
    const { getFieldDecorator } = this.props.form;

    if (!this.state.showModal) {
      return <div />;
    }
    const type = this.state.selectedRow.subcategories ? 'category' : 'subcategory';
    return (
      <Modal
        title={this.state.isAddNew ? 'Add new category' : `Edit: ${this.state.selectedRow._id}`}
        visible={this.state.showModal}
        onCancel={this.handleCancel}
        footer={[
          <Button key="back" size="large" onClick={this.handleCancel}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" size="large" onClick={this.handleSubmit} loading={this.props.categoryLoading || this.props.subcategoryLoading}>
            Save
          </Button>,
        ]}
      >
        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} label="Type" hasFeedback>
            {getFieldDecorator('type', {
              rules: [
                {
                  required: true,
                  message: 'Please input Type',
                },
              ],
              initialValue: type === 'category' ? 'Category' : 'Subcategory',
            })(<Input disabled />)}
          </FormItem>
          {type === 'subcategory' && (
            <FormItem {...formItemLayout} label="Category" hasFeedback>
              {getFieldDecorator('parent', {
                initialValue: this.state.selectedRow.parent,
              })(
                <Select>
                  {this.state.categories.map((cat) => (
                    <Option value={cat._id}>
                      <i className={cn(cat.icon, 'tp-icon')} /> &nbsp; {cat.name}
                    </Option>
                  ))}
                </Select>,
              )}
            </FormItem>
          )}
          <FormItem {...formItemLayout} label="Name" hasFeedback>
            {getFieldDecorator('name', {
              rules: [
                {
                  required: true,
                  message: 'Please input Name',
                },
              ],
              initialValue: this.state.selectedRow.name,
            })(<Input />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Slug" hasFeedback>
            {getFieldDecorator('slug', {
              rules: [
                {
                  required: true,
                  message: 'Please input Slug',
                },
              ],
              initialValue: this.state.selectedRow.slug,
            })(<Input />)}
          </FormItem>
          {type === 'category' && (
            <FormItem {...formItemLayout} label="Icon" hasFeedback>
              {getFieldDecorator('icon', {
                rules: [
                  {
                    required: true,
                    message: 'Please choose Icon',
                  },
                ],
                initialValue: this.state.selectedRow.icon,
              })(
                <Select>
                  {iconlist.map((iconName) => (
                    <Option value={iconName}>
                      <i className={cn(iconName, 'tp-icon')} /> &nbsp; {iconName}
                    </Option>
                  ))}
                </Select>,
              )}
            </FormItem>
          )}
          {this.state.selectedRow._id && (
            <FormItem>
              {getFieldDecorator('_id', {
                initialValue: this.state.selectedRow._id,
              })(<Input type="hidden" />)}
            </FormItem>
          )}
        </Form>
      </Modal>
    );
  }

  renderContentTable() {
    let { categories } = this.state;
    categories = _.orderBy(categories, 'index');
    const catLenght = categories ? categories.length : 0;
    const content = _.map(categories, (cat) => {
      const subLength = cat.subcategories.length;
      cat.length = catLenght;
      cat.subcategories = _.orderBy(cat.subcategories, 'index');
      cat.subcategories.map((subcat, i) => {
        subcat.length = subLength;
        subcat.parent = cat._id;
        subcat.parentId = cat._id;
        subcat.rowIndex = i;
        return subcat;
      });
      cat.children = cat.subcategories;

      return cat;
    });
    return <Table rowKey="_id" columns={this.columns} dataSource={content} pagination={false} />;
  }

  render() {
    const { categoriesLoading, categoryLoading, subcategoryLoading, deleteCategoryLoading } = this.props;
    return (
      <div>
        <div className="page-header">{this.props.BreadCrumb}</div>
        <div className="content">
          <Spin tip="Loading" size="large" spinning={!!categoriesLoading || !!categoryLoading || !!subcategoryLoading || !!deleteCategoryLoading}>
            <div className={cn(classes.addBtnContainer, 'text-right')}>
              <Button type="primary" onClick={this.onAddNewCategory}>
                <Icon type="plus" size="large" />
                Add new category
              </Button>
            </div>
            {this.renderContentTable()}
            {this.renderModal()}
          </Spin>
        </div>
      </div>
    );
  }
}
export default connect((state) => ({}), { categorySwapIndex, subcategorySwapIndex })(Form.create()(Category));
